import React from 'react';
import IconButtonBase from './IconButtonBase';
import { TIconButton } from './types';

const ActionImage = ({ as = 'button', ...rest }: TIconButton) => (
  <IconButtonBase {...rest} as={as} kind="action-image" />
);

export default ActionImage;
